import { GetUserLiveInspectionsResponse } from "@/types/inspections";
import { axiosWithToken } from "@/utils/axios";
import { AxiosResponse } from "axios";

class ServiceClass {
  // Update function signature
  GetUserLiveInspections(
    payload?: Record<string, any>,
  ): Promise<AxiosResponse<GetUserLiveInspectionsResponse>> {
    return axiosWithToken().get<GetUserLiveInspectionsResponse>(
      "/inspections/user_live_inspection",
      {
        params: payload,
      },
    );
  }

  PurchaseBundleViaWallet(payload: any) {
    return axiosWithToken().post("/inspections/buy_bundle", {
      ...payload,
    });
  }
}

const LiveInspectionService = new ServiceClass();
export default LiveInspectionService;
